import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { resolveBackgroundStyle, useLoginType } from '@gn-audio/jss-components';

import LoginCard from 'components/LoginSpot/LoginCard';
import { Card, LoginSpotProps } from 'composables/LoginSpot/LoginSpotTypes';

const LoginSpot = ({ fields }: LoginSpotProps) => {
  const { cards, spotBackground } = fields;
  const { userIsLoggedIn } = useLoginType();
  const spotBackgroundStyle = resolveBackgroundStyle(spotBackground.value as string);

  return (
    <>
      {!userIsLoggedIn && (
        <div style={spotBackgroundStyle}>
          <div className="container grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
            {cards.map((card: Card) => (
              <LoginCard card={card} key={card.id} />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default withDatasourceCheck()(LoginSpot);
